import { ConsentSettings } from 'firebase/analytics';

export const firebaseDefaultConsentSettings: ConsentSettings = {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'denied',
};

export const firebaseAnalyticsEnabledConsentSettings: ConsentSettings = {
  ad_storage: 'denied',
  analytics_storage: 'granted',
  functionality_storage: 'granted',
  personalization_storage: 'granted',
  security_storage: 'denied',
};
